import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { Segment, Form, Radio } from "semantic-ui-react";
import { IAssessment } from "../../../../../Models/Assessment";
import HowImportantModal from "./HowImportantModal";
import { questionChoices  } from "../../../../Enums/TitleEnums";
import styles from "./ModalQuestionBox.module.css"

export interface ModalQuestionBoxProps {
  assessment: IAssessment;
  slideIndex: number;
  nextTaskHandler: () => void;
  questionContentRef: React.RefObject<HTMLDivElement>;
}

const ModalQuestionBox: React.FC<ModalQuestionBoxProps> = ({
  assessment,
  slideIndex,
  nextTaskHandler,
  questionContentRef,
}) => {
  const [showImportanceModal, setShowImportanceModal] = useState(false);
  const [questionForModal, setQuestionForModal] = useState(
    assessment.questionForKey(assessment.infoSlideKeys[slideIndex])
  );
  const [currentAnswer, setCurrentAnswer] = useState(questionForModal.answer);

  useEffect(() => {
    setQuestionForModal(
      assessment.questionForKey(assessment.infoSlideKeys[slideIndex])
    );
    setCurrentAnswer(questionForModal.answer);
  }, [slideIndex, assessment, questionForModal.answer]);

  const handleAnswer = (e: any) => {
    if (e.target.innerText === questionChoices.NO ) {
      questionForModal.setAnswer(e.target.innerText);
      setCurrentAnswer(e.target.innerText);
      setShowImportanceModal(true);
    } else {
      questionForModal.setAnswer(e.target.innerText);
      setCurrentAnswer(e.target.innerText);
    }
  };

  const handleImportanceClose = () => {
    setShowImportanceModal(false);
  };

  const handleImportance = (e: any) => {
    questionForModal.setTimeToComplete(e.target.innerText);
  };

  const goToNextTask = () => {
    setShowImportanceModal(false);
    nextTaskHandler();
  };

  const renderImportanceModal = () => {
    return (
      <HowImportantModal
        howImportant={questionForModal.timeToComplete ?? ""}
        handleSelection={handleImportance}
        onClose={handleImportanceClose}
        nextTaskHandler={goToNextTask}
      />
    );
  };

  return (
    <>
      {showImportanceModal && renderImportanceModal()}
      <Segment className={styles.questionBoxSegment}>
        <p className={styles.questionHeader}>        
          <b>{questionForModal.question}</b>
        </p>
        <Segment basic className={styles.answerButtonSegment}>
          <>
            <Form className={styles.answerForm}>
              <Form.Field className={styles.answerFormField}>
                <Radio
                  label={questionChoices.YES}
                  name="radioGroup"
                  value={questionChoices.YES}
                  checked={currentAnswer === questionChoices.YES}
                  onChange={(e) => handleAnswer(e)}
                  className={styles.answerFormRadioBtn}
                />
              </Form.Field>
              <Form.Field className={styles.answerFormField}>
                <Radio
                  label={questionChoices.NO}
                  name="radioGroup"
                  value={questionChoices.NO}
                  checked={currentAnswer === questionChoices.NO}
                  onChange={(e) => handleAnswer(e)}
                  className={styles.answerFormRadioBtn}
                />
              </Form.Field>
              <Form.Field className={styles.answerFormField}>
                <Radio
                  label={questionChoices.DNA}
                  name="radioGroup"
                  value="N/A"
                  checked={currentAnswer === questionChoices.DNA}
                  onChange={(e) => handleAnswer(e)}
                  className={styles.answerFormRadioBtn}
                />
              </Form.Field>
            </Form>
          </>
        </Segment>
        <div ref={questionContentRef} ></div>
      </Segment>
    </>
  );
};

export default observer(ModalQuestionBox);
